sap.ui.requireSync("jquery.sap.global");
